import { requestGet, requestPost, requestPut, requestDel } from '@/api/request'

const VITE_SERVICE_BASE_URL = import.meta.env.VITE_SERVICE_BASE_URL

/**
 * 创建命书(废弃)
 * @param { string } subject_name - 姓名
 * @param { number } gender - 性别 男||女
 * @param { string } birth_date_solar - 公历生日 '1977/03/26 02:06'
 * @param { string } version - 版本 professional=专业版 plain=白话版
 * @returns
 */
// export const createFateReport = (params) => {
//   return requestPost({
//     url: `/api/readings/generate`,
//     data: params,
//     isFormData: false,
//     baseURL: VITE_SERVICE_BASE_URL,
//     showLoading: false
//     // ,
//     // baseURL: ''
//   })
// }

/**
 * 创建报告
 * @returns
 */
export const createTask = (params) => {
  return requestPost({
    url: `/v1/api/fate_book/create_task/`,
    data: params,
    isFormData: false,
    showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}

/**
 * 查看报告进度
 * @returns
 */
export const getProgress = (task_id) => {
  return requestGet({
    url: `/v1/api/fate_book/progress/${task_id}/`,
    isFormData: false,
    showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}

/**
 * 获取报告json
 * @returns
 */
export const getFateReport = (task_id) => {
  return requestGet({
    url: `/v1/api/fate_book/result/${task_id}/`,
    isFormData: false,
    showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}

/**
 * 获取命书列表
 * @param { integer }  page 页码
 * @returns
 */
export const reportListGet = (params) => {
  return requestPost({
    url: `/v1/api/fate_book/user_report_list/`,
    data: params,
    isFormData: false,
    showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}

/**
 * 获取报告支付状态-报告详情
 * @param { string }  task_id 任务id
 * @param { string }  order_series 订单编码
 * @returns
 */
export const reportDetailGet = (params) => {
  return requestPost({
    url: `/v1/api/fate_book/select_report/`,
    data: params,
    isFormData: false,
    showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}

/**
 * 分享链接查看报告详情
 * @param { string }  task_id 任务id
 * @returns
 */
export const shareReport = (params) => {
  return requestGet({
    url: `/v1/api/fate_book/share_report/`,
    params,
    isFormData: false,
    // showLoading: false,
    baseURL: VITE_SERVICE_BASE_URL
    // ,
    // baseURL: ''
  })
}
